<template>
    <div id="calendar-settings">
        <a-spin :spinning="loading">
            <SupsisButton class="create-reservation" @click="goReservationPage()">Randevu Oluştur</SupsisButton>
            <div
                @click="googleCalendarIntegration"
                class="integretion"
                :style="!!userOAtuh ? 'backgroundColor: #5c5c5c' : 'backgroundColor: #ec4b1d'"
                :aria-disabled="btnEnabled"
                v-if="IsCalendarEnabled()"
            >
                <div>{{ !!userOAtuh ? $t("calendar.googleDisconnect") : $t("calendar.googleConnect") }}</div>
                <div class="material-icons">open_in_new</div>
            </div>
            <div>
                <span style="display: flex">{{ $t("fastWizard.customHoursTimezone") }}</span>
                <a-select
                    style="width: 300px"
                    show-search
                    placeholder="Select Timezone"
                    option-filter-prop="children"
                    v-model="settings.timezone"
                    @change="changeTimezone"
                >
                    <a-select-option :value="tz" v-for="(tz, i) in timezones" :key="i">
                        {{ tz }}
                    </a-select-option>
                </a-select>
            </div>
            <VisibilityChanger v-model="visibilityData" :show-title="false" style="margin-top: 10px" />
        </a-spin>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { log2 } from "../../../utils/log2";
import moment from "moment";
import CONFIG from "../../../config/config";
import VisibilityChanger from "../WhatsappV1/VisibilityChanger.vue";
import SupsisButton from "../../../components/common/SupsisButton.vue";
import { i18n } from "../../../language/index";

const momentTimezoneList = moment.tz.names();
moment.locale("tr");
const log = log2("CalendarSettings");
export default {
    name: "CalendarSettings",
    components: { SupsisButton, VisibilityChanger },
    props: {
        payload: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            notificationTypes: [
                { label: "Email", value: "email" },
                { label: "Notification", value: "notification" },
            ],
            repeats: [
                { label: "minutes", value: "minutes" },
                { label: "hours", value: "hours" },
                { label: "days", value: "days" },
                { label: "weeks", value: "weeks" },
            ],
            userOAtuh: false,
            btnEnabled: false,
            timezones: momentTimezoneList,
            settings: {},
            visibilityData: this.payload.defaultCalendar.visibility,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            connectSuccess: (state) => state.calendar.connectSuccess,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            setWindows: "app/setWindows",
            getCalendarSettings: "calendar/getCalendarSettings",
            isEnableUserAccount: "calendar/isEnableUserAccount",
            calendarDisconnect: "calendar/calendarDisconnect",
            updateSetting: "calendar/updateSetting",
            changeVisibility: "calendar/changeVisibility",
            getCalendarDetail: "calendar/getCalendarDetail",
        }),
        ...mapMutations({
            isAllDeleteEvents: "calendar/isAllDeleteEvents",
        }),
        goReservationPage() {
            this.$router.replace("/reservation");
            this.setWindows({});
        },
        IsCalendarEnabled() {
            return CONFIG.CALENDAR_SERVICE_ENABLED;
        },
        async changeTimezone(value) {
            console.log("changeTimezone", value);
            await this.updateSetting({ userId: this.user._id, setting: "timezone", value });
        },
        cancelGoogleCalendarIntegration() {
            const self = this;
            this.$confirm({
                title: this.$t("calendar.sure"),
                content: this.$t("calendar.disconnectGoogleSure"),
                okText: this.$t("calendar.yes"),
                okType: "danger",
                cancelText: this.$t("calendar.no"),
                onOk: () => {
                    const prop = {
                        title: i18n.messages[`${i18n.locale}`].calendar.deleteEvent,
                        content: i18n.messages[`${i18n.locale}`].calendar.deleteEventConfirm,
                        okText: i18n.messages[`${i18n.locale}`].calendar.yes,
                        okType: "danger",
                        cancelText: i18n.messages[`${i18n.locale}`].calendar.no,
                    };
                    this.$confirm({
                        ...prop,
                        onOk: () => {
                            this.calendarDisconnect({
                                userId: this.user._id,
                                authId: this.userOAtuh._id,
                                isDeleteAll: true,
                            }).then((res) => {
                                this.isAllDeleteEvents();
                                this.userOAtuh = false;
                            });
                        },
                        onCancel: () => {
                            this.calendarDisconnect({
                                userId: this.user._id,
                                authId: this.userOAtuh._id,
                                isDeleteAll: false,
                            }).then((res) => {
                                this.userOAtuh = false;
                            });
                        },
                    });
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        },
        async googleCalendarIntegration() {
            if (!!this.userOAtuh) {
                await this.cancelGoogleCalendarIntegration();
                await this.setWindows({});
            } else {
                const oauth2Endpoint = CONFIG.CALENDAR.OAUTH2_ENDPOINT;
                const params = {
                    access_type: "offline",
                    client_id: CONFIG.CALENDAR.CLIENT_ID,
                    redirect_uri: CONFIG.CALENDAR.REDIRECT_URI,
                    response_type: "code",
                    scope: CONFIG.CALENDAR.SCOPE,
                    include_granted_scopes: "true",
                    state: `${this.site._id}/${this.user._id}`,
                };

                const url = `${oauth2Endpoint}?&client_id=${params.client_id}&redirect_uri=${params.redirect_uri}&response_type=${params.response_type}&scope=${params.scope}&include_granted_scopes=${params.include_granted_scopes}&state=${params.state}`;
                console.log(url);
                this.oauthWindw = window.open(url, "_blank", "width=600,height=600");
                window.oauthWindw = this.oauthWindw;
            }
        },
    },
    async mounted() {
        this.loading = true;
        this.isEnableUserAccount({ userId: this.user._id }).then((res) => {
            this.userOAtuh = res;
            this.btnEnabled = true;
        });
        const calendarDetail = await this.getCalendarDetail(this.payload.defaultCalendar._id);
        this.visibilityData = calendarDetail.visibility;

        this.getCalendarSettings({ userId: this.user._id }).then((res) => {
            this.settings = res;
            this.loading = false;
        });

        this.loading = false;
    },
    watch: {
        visibilityData(val) {
            this.changeVisibility({
                calendarId: this.payload.defaultCalendar._id,
                visibility: { users: val.users, departments: val.departments },
            });
        },
        connectSuccess(val) {
            this.userOAtuh = val;
            window.oauthWindw?.close();
        },
    },
};
</script>

<style lang="scss">
.ant-modal-confirm {
    z-index: 999999999999;
    position: absolute;
}
</style>

<style lang="scss" scoped>
#calendar-settings {
    background-color: #ffffff;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;

    .create-reservation {
        margin-bottom: 20px;
        border-radius: 10px;
        cursor: pointer;
    }

    .integretion {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        cursor: pointer;
        width: fit-content;
        color: white;
        padding: 5px;
        border-radius: 10px;

        .material-icons {
            font-size: 15px;
            margin-left: 10px;
        }
    }

    .notification {
        width: fit-content;

        .title {
            font-size: 20px;
            margin-bottom: 10px;
        }

        .values {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;

            .multi-select-type {
                min-width: 120px;
                max-width: 120px;
            }

            .multi-select-time {
                min-width: 90px;
                max-width: 90px;
            }

            .time {
                border: 1px solid rgba(116, 116, 116, 0.29);
                border-radius: 7px;
                padding: 5px;
                width: 60px;
                margin: 0 10px;
            }

            .close-icon {
                margin-left: 10px;
                font-size: 20px;
                cursor: pointer;
            }
        }

        .buttons {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            .new-notification {
                cursor: pointer;
                border: 1px solid rgba(116, 116, 116, 0.29);
                border-radius: 10px;
                padding: 7px;
                width: fit-content;
                display: flex;
                color: rgb(26, 115, 232);
                align-items: center;

                .close-icon {
                    margin-right: 10px;
                    font-size: 20px;
                    cursor: pointer;
                    color: rgb(26, 115, 232);
                }
            }

            .save-btn {
                background-color: rgb(26, 115, 232);
                color: #ffffff;
                padding: 7px;
                border-radius: 10px;
                cursor: pointer;
            }
        }
    }
}
</style>
